<script setup lang="ts">
const config = useRuntimeConfig()
const search = defineModel()
const platform = useState('platform')

const props = defineProps({
  widget: { type: Boolean, default: false },
})

const {data: activityTypes} = await useApi('/activity-type', {
  transform: (res) => {
    res.data.unshift({name: '- Tout -', slug: null})
    return res.data.map(function (a) {
      //a.icon = getIcon(a.slug)
      a.label = a.name
      a.icon = null
      return a
    });
  },
});

const selectedLocation = ref(null)
if (search.value.coordinates) {
  selectedLocation.value = {
    coordinates: search.value.coordinates,
    value: search.value.value,
  }
}

watch(selectedLocation, function() {
  search.value.coordinates = selectedLocation.value ? selectedLocation.value.coordinates : null
  search.value.value = selectedLocation.value ? selectedLocation.value.value : null
}, {deep: true});

const domainsArray = computed({
  get() {
    return search.value.domain ? search.value.domain.split(',') : [];
  },
  set(newValue) {
    search.value.domain = newValue.join(',');
  }
});
</script>

<template>
  <div class="flex flex-col sm:grid gap-x-10 gap-y-2 sm:items-center my-20" :class="widget ? 'sm:grid-cols-4' : 'sm:grid-cols-3'">
    <div class="text-3xl font-bold text-primary row-span-2" v-if="!widget">
      Quelle mission<br>cherchez-vous ?
    </div>
    <div :class="widget ? 'col-start-2' : ''">
      <UFormField label="Type d'activité">
        <USelect v-model="search.activity" :items="activityTypes" value-key="slug" label-key="name" size="md" class="w-full" />
      </UFormField>
    </div>
    <div>
      <UFormField :label="platform.type === 'city' ? 'Quartier' : 'Ville'">
        <InputNeighborhood v-if="platform.type === 'city'" v-model="selectedLocation" class="w-full" />
        <InputCity v-else v-model="selectedLocation" :types="['place', 'locality', 'postcode']" class="w-full"/>
      </UFormField>
    </div>
    <div class="col-span-2 col-start-2">
      <SearchDomainInput v-model="domainsArray" v-if="platform.type !== 'network' || platform.id === '00000000-0000-0000-0000-000000000000'" />
    </div>
  </div>
</template>